export default "__VITE_ASSET__CCe2PhZm__"